(() => {
  if (window.awSwymInitialized) {
    return;
  }

  window.awSwymInitialized = true;

  const labels = {
    wishlist: "お気に入り",
    saveForLater: "あとで買う",
    restockSuccess: "ご登録ありがとうございます。商品が再入荷しましたら、メールにてご案内いたします。"
  };

  const updateText = (selector, text, root = document) => {
    root.querySelectorAll(selector).forEach((element) => {
      if (element.textContent.trim() !== text) {
        element.textContent = text;
      }
    });
  };

  const syncSwymUi = (root = document) => {
    updateText(".swym-tab-wishlist", labels.wishlist, root);
    updateText(".swym-tab-sfl", labels.saveForLater, root);
    updateText(".swym-sfl-title", labels.saveForLater, root);

    root.querySelectorAll("#swym-remind-me-subscribed-success").forEach((container) => {
      const successMessage = container.querySelector(".swym-success-msg");

      if (successMessage && successMessage.textContent.trim() !== labels.restockSuccess) {
        successMessage.textContent = labels.restockSuccess;
      }

      const actionButton = container.querySelector("#remind-me-subscribe-btn");

      if (actionButton) {
        actionButton.style.display = "none";
      }
    });
  };

  let syncScheduled = false;

  const scheduleSync = () => {
    if (syncScheduled) {
      return;
    }

    syncScheduled = true;

    window.requestAnimationFrame(() => {
      syncScheduled = false;
      syncSwymUi(document);
    });
  };

  const init = (root = document) => {
    syncSwymUi(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  if (document.body) {
    const observer = new MutationObserver(() => {
      scheduleSync();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
